module.exports = __webpack_public_path__ + "static/D365-sales-and-marketing-9cdb7f90d2c5772c47e56464b7dc02d1.png";